import { Component, OnInit, Input } from '@angular/core';
import {Rate} from '../../api/model/reservation/rate/rate.model';

@Component({
    selector: 'stay-mgmt-policies',
    templateUrl: './policies.component.html',
    styleUrls: ['./policies.component.scss']
})
export class PoliciesComponent implements OnInit {
    @Input() messages;
    private _rate: Rate;
    rateDepositPolicyText = null;
    rateCancellationPolicyText = '';
    rateSecondaryCancellationPolicyText = '';
    refundableStatus = false;
    rateSecondaryCancellationPolicyAvailable = false;

    constructor() {

    }
    @Input()
    set rate(rate: Rate) {
      if (rate) {
        this._rate = rate;
        this._initPolicies();
      }
    }
    get rate() {
      return this._rate;
    }
/**
Business Logic for displaying cancellation policies

If rate.cancellationPolicy is not empty, show that value;  otherwise, show the hard-coded default cancellation policy (refundable or non-refundable).
If rate.secondaryCancellationPolicies is not empty, show that value; otherwise, show nothing
 **/
    setCancellationPolicy() {
      if (this.rate.cancellationPolicy && this.rate.cancellationPolicy.primaryPolicy) {
        this.rateCancellationPolicyText = this.rate.cancellationPolicy.primaryPolicy;
      } else {

            if (this.refundableStatus) {
              this.rateCancellationPolicyText = 'Canceling your reservation before the day of reservation will result in no charge.' +
               'Canceling your reservation on or after the day of reservation, or failing to show, will result in a charge equal to the first night s stay per room to your credit card.' +
               'Taxes may apply. Failing to call or show before check-out time after the first night of a reservation will result in cancellation of the remainder of your reservation.';

            } else {
              this.rateCancellationPolicyText = 'Canceling your reservation or failing to arrive will result in forfeiture of your deposit.' +
              'Taxes may apply. Failing to call or show before check-out time after the first night of a reservation will result in cancellation of the remainder of your reservation.';
            }
      }
      this.setSecondaryCancellationPolicy();
    }

    setSecondaryCancellationPolicy() {
      if (this.rate.cancellationPolicy && this.rate.cancellationPolicy.secondaryPolicies.length > 0) {
        this.rateSecondaryCancellationPolicyAvailable = true;
        this.rateSecondaryCancellationPolicyText = this.rate.cancellationPolicy.secondaryPolicies.join(' ');
      }
    }

    setRefundableStatus() {
      this.refundableStatus = this.rate.refundable;
    }

    private _initPolicies() {
        this.setRefundableStatus();
        this.setCancellationPolicy();
    }

    ngOnInit() {

    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/policies/policies.component.ts